import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TourService } from 'src/app/services/tour.service';

@Component({
  selector: 'app-tour-tooltip',
  templateUrl: './tour-tooltip.component.html',
  styleUrls: ['./tour-tooltip.component.scss'],
  imports: [IonicModule, CommonModule, TranslateModule],
})
export class TourTooltipComponent implements OnInit, OnDestroy {
  @Input() content = '';
  @Input() highlightStyle: any = {};
  @Input() tooltipStyle: any = {};
  @Input() hasPrev = false;
  @Input() hasNext = false;
  @Input() prev: () => void = () => {};
  @Input() next: () => void = () => {};

  constructor(public tourService: TourService) {}

  ngOnInit() {
    document.body.style.overflow = 'hidden';
  }
  ngOnDestroy() {
    document.body.style.overflow = '';
  }
  finishTour() {
    this.tourService.finishTour();
  }
}